import React, { Component } from 'react'
import { CogWheel } from '../../icons/cogWheel'
import classnames from 'classnames'

import { AdminBannerAvatar } from './adminBanner/adminBannerAvatar'
import { AdminBannerTabs } from './adminBanner/adminBannerTabs'
import { AdminBannerDropdown } from './adminBanner/adminBannerDropdown'
import { User } from '../../core/types'

export interface Props {
  user: User
  context: string
}

export interface State {
  isDropdownActive: boolean
}

export class AdminBanner extends Component<Props, State> {
  static displayName = 'AdminBanner'

  state = {
    isDropdownActive: false,
  }

  toggleIsDropdownActive = () => {
    this.setState((state) => ({ isDropdownActive: !state.isDropdownActive }))
  }

  render() {
    const { isDropdownActive } = this.state
    const { user, context } = this.props

    return (
      <div data-testid="admin-banner" className={classnames('user-banner')}>
        <AdminBannerAvatar user={user} context={context} />
        <AdminBannerTabs user={user} />
        <AdminBannerDropdown
          userId={user.id}
          isDropdownActive={isDropdownActive}
        />
        <button
          className="button__no-style user-banner__dropdown-toggle"
          onClick={this.toggleIsDropdownActive}
        >
          {isDropdownActive ? <CogWheel color="#007aff" /> : <CogWheel />}
        </button>
      </div>
    )
  }
}
